// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".export-list[data-v-17905940]{margin:-10px 0}.publication-overview[data-v-17905940]{padding:25px;border-top:1px solid #d9dadb;//border-bottom:1px solid #d9dadb}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
